import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { CartPaymentMethod } from '@ridango/components/lib/purchase/purchase.model';
import Env from '@ridango/core/env';

@Component({
    selector: 'gl-multiple-payment-methods-v2',
    templateUrl: './multiple-payment-methods-v2.component.html',
    styleUrls: ['./multiple-payment-methods-v2.component.scss']
})
export class MultiplePaymentMethodsV2Component {
    @Input() methods: CartPaymentMethod[] = [];
    @Input() selectedMethod: CartPaymentMethod = null;
    @Input() tabIndex = 0;
    @Output() methodSelected = new EventEmitter<any>();

    constructor(@Inject('ENV') public env: Env) {}

    select(method) {
        this.methodSelected.emit(method);
    }

    isSelected(pm: CartPaymentMethod) {
        return (
            this.selectedMethod &&
            !this.selectedMethod['id'] &&
            pm.paymentMethodId === this.selectedMethod.paymentMethodId &&
            ((!this.selectedMethod.paymentMethodId && !pm.paymentMethodId) ||
                pm.paymentMethodId === this.selectedMethod.paymentMethodId)
        );
    }
}
